<template>
  <EventDetails :if="eventId" :eventId="eventId"/>
</template>

<script>
import EventDetails from '@/components/EventDetails.vue'

export default {
  name: 'EventDetailsManagement',
  components: {
   EventDetails
  },
  data: () => {
    return {
      eventId: undefined
    }
  },
  mounted() {
    const routeId = this.$route.params.id
    this.eventId = routeId
  }
}
</script>
